<template>
  <div class="centent">
    <div class="titlefont" :class="{ sSixKeys: sSixKeys }">
      <div class="titleAnimation">
        <div class="title">针对四类人群 研发专属项目</div>
        <div class="desc">来，一起做朝阳行业的“弄潮儿”</div>
      </div>
    </div>
    <div class="cont">
      <div>
        <ul class="sixItems" :class="{ sSixKeys: sSixKeys }">
          <li
            class="item"
            :class="{
              itemA: index == 0,
              itemB: index == 1,
              itemC: index == 2,
              itemD: index == 3,
            }"
            v-for="(item, index) in sixthScreen"
            :key="index"
          >
            <p class="tit"><img :src="item.url" /></p>
            <p class="text">{{ item.title }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sixthScreen: {
      type: Array,
      required: true,
      default: () => {},
    },
    sSixKeys: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
